export const data = {
  organizations: [{
    id: '584905001604743668',
    name: 'Boundless',
  }, {
    id: '224936',
    name: 'Evolve Squads',
  }, {
    id: '667658644757676298',
    name: 'EDETEK, INC.',
  }, {
    id: '733523789307969556',
    name: 'Logamic',
  }, {
    id: '733523789307969555',
    name: 'Asgard Energy',
  }, {
    id: '637259347272926477',
    name: 'Forbattring',
  }, {
    id: '692428442708213764',
    name: 'AIKIT Digital',
  }, {
    id: '667658644757676199',
    name: 'Hoverstate',
  }, {
    id: '692428442708213768',
    name: 'GoGoGrandparent',
  }, {
    id: '692428442708213765',
    name: 'Reintech',
  }],
  networks: [{
    id: 'L_584905001604749341',
    name: 'BRANS-HotelOfTheFuture - 1-HA',
    enrollmentString: null,
    tags: [
      'IHG_VPN',
    ],
    productTypes: [
      'appliance',
      'camera',
      'switch',
      'wireless',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '584905001604743668',
  }, {
    id: 'L_584905001604752721',
    name: 'Migration Test - BRANS TEST',
    enrollmentString: null,
    tags: [
      'IHG_VPN',
    ],
    productTypes: [
      'appliance',
      'camera',
      'switch',
      'wireless',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '224936',
  }, {
    id: 'N_584905001604785895',
    name: 'BRANX-AWS-HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '667658644757676298',
  }, {
    id: 'N_584905001604790008',
    name: 'BRANS-IHG_HII_MDM',
    enrollmentString: null,
    tags: [],
    productTypes: [],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '224936',
  }, {
    id: 'L_584905001604745041',
    name: 'BERIW - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
      'switch',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '584905001604743668',
  }, {
    id: 'L_584905001604745086',
    name: 'MUCWT - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
      'switch',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '584905001604743668',
  }, {
    id: 'L_584905001604745145',
    name: 'LONCY - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
      'switch',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '224936',
  }, {
    id: 'L_584905001604745147',
    name: 'LONBW - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [
      'IHG_VPN',
    ],
    productTypes: [
      'appliance',
      'wireless',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '733523789307969556',
  }, {
    id: 'L_584905001604745152',
    name: 'ZDVDA - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '637259347272926477',
  }, {
    id: 'L_584905001604745154',
    name: 'FRAHA - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [
      'IHG_VPN',
    ],
    productTypes: [
      'appliance',
      'camera',
      'switch',
      'wireless',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '733523789307969556',
  }, {
    id: 'L_584905001604745156',
    name: 'DUSHA - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'switch',
      'wireless',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '733523789307969556',
  }, {
    id: 'L_584905001604745157',
    name: 'SOFCO - Hotel - EUR - MX84 - HA',
    enrollmentString: null,
    tags: [],
    productTypes: [
      'appliance',
    ],
    created_at: '2022-01-18T23:35:36.878247Z',
    updated_at: '2022-01-18T23:35:36.878268Z',
    organizationId: '733523789307969555',
  }],
  networksTags: [
    '3DN',
    'Active',
    'AirAngel',
    'BODHA',
    'BRANS_IR',
    'BRUPR',
    'CompCulture',
    'Crowne_Plaza',
    'DNDDD',
    'HospWifi',
    'Hotel_Indigo',
    'IHG_Admin',
    'InterContinental',
    'KBPHA',
    'LGWUK',
    'LONSA',
  ],
  devicesTags: [
    'ADMIN_INSTALLED',
    'ADOPLAFAM',
    'B1FOffice',
    'BusinessCenter',
    'California_Room',
    'Digital',
    'E4_300',
    'F02_Card',
    'Gallery',
    'Harvester',
    'Microsoft',
    'NOT_INSTALLED',
    'Ohne_VA',
    'StinsonHall',
  ],
  filtersDevice_types: [{
    displayName: 'Wireless',
    filterName: 'wireless',
  }, {
    displayName: 'Switch',
    filterName: 'switch',
  }, {
    displayName: 'Appliance',
    filterName: 'appliance'
  }, {
    displayName: 'Camera',
    filterName: 'camera'
  }, {
    displayName: 'Sensor',
    filterName: 'sensor'
  }],
  filtersDevice_models: [
    'MS120-24',
    'MS120-48FP',
    'MS120-8FP',
    'MS125-24',
    'MS125-24P',
    'MS125-48FP',
    'MS125-48LP',
    'MS210-24',
  ],
  devices: [{
    claimedAt: '2020-04-27T14:35:01.228073Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.705599Z',
    default_expiration_date: '2025-04-27T14:35:01.228073Z',
    default_time_remaining_in_days: 1194,
    id: 1,
    licenseExpirationDate: null,
    mac: '68:3A:1E:F4:29:7E',
    deviceModel: 'MS410-16',
    name: 'LISHA-AGG-01',
    network: {
      name: 'BRANS-HotelOfTheFuture - 1-HA',
    },
    orderNumber: '5S4904341',
    organization: {
      name: 'Boundless',
    },
    deviceType: 'switch',
    serial: 'Q2AW-5TJK-ZK2F',
    deviceTags: ['ACH', 'FTP', 'Gran', 'Nexura'],
    updated_at: '2022-01-18T23:37:35.705616Z',
  }, {
    claimedAt: '2017-02-10T09:56:08.058314Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.710708Z',
    default_expiration_date: '2022-02-10T09:56:08.058314Z',
    default_time_remaining_in_days: 22,
    id: 2,
    licenseExpirationDate: null,
    mac: 'E0:55:3D:2F:11:9E',
    deviceModel: 'MS410-16',
    name: 'C47785_FRAHA_MS410-16_SW00-2',
    network: {
      name: 'Migration Test - BRANS TEST',
    },
    orderNumber: '5S7203405',
    organization: {
      name: 'Evolve Squads',
    },
    deviceType: 'switch',
    serial: 'Q2AW-C3QR-VFZA',
    deviceTags: ['Nexura'],
    updated_at: '2022-01-18T23:37:35.710717Z',
  }, {
    claimedAt: '2017-02-10T09:56:08.077946Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.713638Z',
    default_expiration_date: '2022-02-10T09:56:08.077946Z',
    default_time_remaining_in_days: 22,
    id: 3,
    licenseExpirationDate: null,
    mac: 'E0:55:3D:86:06:72',
    deviceModel: 'MS410-16',
    name: 'C47784_FRAHA_MS410-16_SW00-1',
    network: {
      name: 'BRANX-AWS-HA',
    },
    orderNumber: '5S7203405',
    organization: {
      name: 'EDETEK, INC.',
    },
    deviceType: 'switch',
    serial: 'Q2AW-DGQP-5S3L',
    deviceTags: ['FTP', 'Gran'],
    updated_at: '2022-01-18T23:37:35.713651Z',
  }, {
    claimedAt: '2018-01-17T16:34:06.019245Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.716135Z',
    default_expiration_date: '2023-01-17T16:34:06.019245Z',
    default_time_remaining_in_days: 363,
    id: 4,
    licenseExpirationDate: null,
    mac: 'E0:55:3D:86:58:C6',
    deviceModel: 'MS410-16',
    name: 'C48020_ZRHHA_MS410-16_SW07',
    network: {
      name: 'BRANS-IHG_HII_MDM',
    },
    orderNumber: '5S8804092',
    organization: {
      name: 'Evolve Squads',
    },
    deviceType: 'switch',
    serial: 'Q2AW-E943-S3AL',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.716143Z',
  }, {
    claimedAt: '2019-02-22T12:42:18.636552Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.718648Z',
    default_expiration_date: '2024-02-22T12:42:18.636552Z',
    default_time_remaining_in_days: 764,
    id: 5,
    licenseExpirationDate: null,
    mac: 'E0:55:3D:86:EA:DE',
    deviceModel: 'MS410-16',
    name: 'Fiber Core',
    network: {
      name: 'BERIW - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S8662929',
    organization: {
      name: 'Boundless',
    },
    deviceType: 'switch',
    serial: 'Q2AW-H9RX-3F7Q',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.718654Z',
  }, {
    claimedAt: '2018-01-17T16:34:06.040271Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.721285Z',
    default_expiration_date: '2023-01-17T16:34:06.040271Z',
    default_time_remaining_in_days: 363,
    id: 6,
    licenseExpirationDate: null,
    mac: 'E0:55:3D:86:7B:7E',
    deviceModel: 'MS410-16',
    name: 'C48020_ZRHHA_MS410-16_SW08',
    network: {
      name: 'BERIW - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S8804092',
    organization: {
      name: 'Boundless',
    },
    deviceType: 'switch',
    serial: 'Q2AW-HWHH-8233',
    deviceTags: ['ACH'],
    updated_at: '2022-01-18T23:37:35.721298Z',
  }, {
    claimedAt: '2019-05-02T11:55:37.218029Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.723844Z',
    default_expiration_date: '2024-05-01T11:55:37.218029Z',
    default_time_remaining_in_days: 833,
    id: 7,
    licenseExpirationDate: null,
    mac: 'AC:17:C8:FB:0F:C4',
    deviceModel: 'MS410-16',
    name: 'HEGVAHASWCORE1',
    network: {
      name: 'MUCWT - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S1802295',
    organization: {
      name: 'Boundless',
    },
    deviceType: 'switch',
    serial: 'Q2AW-UC2W-9QHB',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.723852Z',
  }, {
    claimedAt: '2019-05-02T11:55:37.227381Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.726326Z',
    default_expiration_date: '2024-05-01T11:55:37.227381Z',
    default_time_remaining_in_days: 833,
    id: 8,
    licenseExpirationDate: null,
    mac: 'AC:17:C8:FB:16:4C',
    deviceModel: 'MS410-16',
    name: 'HEGVAHASWCORE2',
    network: {
      name: 'LONCY - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S1802295',
    organization: {
      name: 'Evolve Squads',
    },
    deviceType: 'switch',
    serial: 'Q2AW-UT2V-PQ96',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.726333Z',
  }, {
    claimedAt: '2020-03-10T17:21:16.817381Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.728556Z',
    default_expiration_date: '2025-03-10T17:21:16.817381Z',
    default_time_remaining_in_days: 1146,
    id: 9,
    licenseExpirationDate: null,
    mac: '34:56:FE:CA:8F:AB',
    deviceModel: 'MS120-8',
    name: 'Internet Switch',
    network: {
      name: 'LONBW - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S7179718',
    organization: {
      name: 'Logamic',
    },
    deviceType: 'switch',
    serial: 'Q2AX-2NYK-6NRU',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.728563Z',
  }, {
    claimedAt: '2018-11-27T07:07:33.105390Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.731093Z',
    default_expiration_date: '2023-11-27T07:07:33.105390Z',
    default_time_remaining_in_days: 677,
    id: 10,
    licenseExpirationDate: null,
    mac: '34:56:FE:29:16:F2',
    deviceModel: 'MS120-8',
    name: 'BERCT - SW26 - FO Back Office',
    network: {
      name: 'ZDVDA - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S6353094',
    organization: {
      name: 'Forbattring',
    },
    deviceType: 'switch',
    serial: 'Q2AX-4CW9-PH3R',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.731100Z',
  }, {
    claimedAt: '2018-10-22T14:53:29.111052Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.733485Z',
    default_expiration_date: '2023-10-22T14:53:29.111052Z',
    default_time_remaining_in_days: 641,
    id: 11,
    licenseExpirationDate: null,
    mac: '34:56:FE:29:29:82',
    deviceModel: 'MS120-8',
    name: 'MANOS-AS-12 (Events)',
    network: {
      name: 'FRAHA - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S9157643',
    organization: {
      name: 'Logamic',
    },
    deviceType: 'switch',
    serial: 'Q2AX-6667-C7ZY',
    deviceTags: ['FTP', 'Gran', 'Nexura'],
    updated_at: '2022-01-18T23:37:35.733493Z',
  }, {
    claimedAt: '2018-11-27T07:07:33.164534Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.736031Z',
    default_expiration_date: '2023-11-27T07:07:33.164534Z',
    default_time_remaining_in_days: 677,
    id: 12,
    licenseExpirationDate: null,
    mac: '34:56:FE:29:2A:27',
    deviceModel: 'MS120-8',
    name: 'BERCT - SW25 - HR',
    network: {
      name: 'DUSHA - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S6353094',
    organization: {
      name: 'Logamic',
    },
    deviceType: 'switch',
    serial: 'Q2AX-679R-DLW2',
    deviceTags: [],
    updated_at: '2022-01-18T23:37:35.736039Z',
  }, {
    claimedAt: '2018-11-27T07:07:33.172157Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.738552Z',
    default_expiration_date: '2023-11-27T07:07:33.172157Z',
    default_time_remaining_in_days: 677,
    id: 13,
    licenseExpirationDate: null,
    mac: '34:56:FE:29:2A:7F',
    deviceModel: 'MS120-8',
    name: 'BERCT - SW09 - Reservations',
    network: {
      name: 'SOFCO - Hotel - EUR - MX84 - HA',
    },
    orderNumber: '5S6353094',
    organization: {
      name: 'Asgard Energy',
    },
    deviceType: 'switch',
    serial: 'Q2AX-697E-3Q9S',
    deviceTags: ['Gran'],
    updated_at: '2022-01-18T23:37:35.738562Z',
  }, {
    claimedAt: '2018-11-27T07:07:33.181027Z',
    compliance_status: 'active',
    createdAt: '2022-01-18T23:37:35.740798Z',
    default_expiration_date: '2023-11-27T07:07:33.181027Z',
    default_time_remaining_in_days: 677,
    id: 14,
    licenseExpirationDate: null,
    mac: '34:56:FE:29:2A:D7',
    deviceModel: 'MS120-8',
    name: 'BERCT - SW24 - Concierge',
    network: {
      name: 'BRANS-HotelOfTheFuture - 1-HA',
    },
    orderNumber: '5S6353094',
    organization: {
      name: 'Boundless',
    },
    deviceType: 'switch',
    serial: 'Q2AX-6A7N-4AX4',
    deviceTags: ['Gran', 'Nexura'],
    updated_at: '2022-01-18T23:37:35.740805Z',
  }],
  device_claims: [{
    complianceStatus: 'active',
    date: '2022-01-18',
    devicesClaimed: 5,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-18T12:36:32.874998Z',
    timeLeft: 1825,
  }, {
    complianceStatus: 'active',
    date: '2022-01-17',
    devicesClaimed: 4,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-17T22:57:38.634655Z',
    timeLeft: 1824,
  }, {
    complianceStatus: 'active',
    date: '2022-01-16',
    devicesClaimed: 1,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-16T09:31:52.091914Z',
    timeLeft: 1823,
  }, {
    complianceStatus: 'active',
    date: '2022-01-14',
    devicesClaimed: 50,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-14T00:55:01.021422Z',
    timeLeft: 1821,
  }, {
    complianceStatus: 'active',
    date: '2022-01-13',
    devicesClaimed: 5,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-13T22:13:47.966633Z',
    timeLeft: 1820,
  }, {
    complianceStatus: 'active',
    date: '2022-01-12',
    devicesClaimed: 200,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-12T03:33:42.961712Z',
    timeLeft: 1819,
  }, {
    complianceStatus: 'active',
    date: '2022-01-11',
    devicesClaimed: 22,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-11T19:32:28.073973Z',
    timeLeft: 1818,
  }, {
    complianceStatus: 'active',
    date: '2022-01-10',
    devicesClaimed: 9,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-10T01:34:47.015158Z',
    timeLeft: 1817,
  }, {
    complianceStatus: 'active',
    date: '2022-01-08',
    devicesClaimed: 1,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-08T17:26:08.153388Z',
    timeLeft: 1815,
  }, {
    complianceStatus: 'active',
    date: '2022-01-07',
    devicesClaimed: 633,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-07T17:08:54.343507Z',
    timeLeft: 1814,
  }, {
    complianceStatus: 'active',
    date: '2022-01-06',
    devicesClaimed: 253,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-06T18:19:27.723701Z',
    timeLeft: 1813,
  }, {
    complianceStatus: 'active',
    date: '2022-01-05',
    devicesClaimed: 9,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-05T12:25:45.403109Z',
    timeLeft: 1812,
  }, {
    complianceStatus: 'active',
    date: '2022-01-04',
    devicesClaimed: 6,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-04T23:02:03.208634Z',
    timeLeft: 1811,
  }, {
    complianceStatus: 'active',
    date: '2022-01-03',
    devicesClaimed: 73,
    licenseDailyCost: null,
    licenseKey: null,
    licenseType: null,
    terminationDate: '2027-01-03T13:46:57.308134Z',
    timeLeft: 1810,
  }],
  'device_claims2022-01-18': [{
    date: '2022-01-18',
    deviceModel: 'MR33',
    deviceSerial: 'Q2PD-Y7K9-JJS6',
    deviceType: 'wireless',
    networkName: 'SSLCP-CP-El Salvador-LATAM-HWF',
    organizationName: 'IHG_AMER_CROWNE_PLAZA',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MS120-48LP',
    deviceSerial: 'Q4AG-9SXU-MG8W',
    deviceType: 'switch',
    networkName: 'HOUSN-EX-Roseneurg TX-PTS',
    organizationName: 'IHG_AMER_EX_SOUTH_CENTRAL',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MS120-48LP',
    deviceSerial: 'Q4AG-MMCA-5R93',
    deviceType: 'switch',
    networkName: 'HOUSN-EX-Roseneurg TX-PTS',
    organizationName: 'IHG_AMER_EX_SOUTH_CENTRAL',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR30H',
    deviceSerial: 'Q2RD-L9ZU-XS2L',
    deviceType: 'wireless',
    networkName: 'MIAPA-KI-Miami Beach FL-SFI',
    organizationName: 'IHG_AMER_KIMPTON',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-HQXC-TR5C',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-3TDA-EHJ4',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-G7LU-39UZ',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-PBFA-MP3P',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-TRCP-KDTP',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR42',
    deviceSerial: 'Q2KD-PBKQ-L3UQ',
    deviceType: 'wireless',
    networkName: 'POMBY-CP-Port Moresby PG-RVT-Guest',
    organizationName: 'IHG_EMEAA_EAST_AUAJ_ENT',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-G8QP-QAGQ',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-6NMW-P7JK',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-VKFF-DR43',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }, {
    date: '2022-01-18',
    deviceModel: 'MR36',
    deviceSerial: 'Q3AJ-8HPW-S63U',
    deviceType: 'wireless',
    networkName: 'RACWA-SB-Mount Pleasant WI-OVN',
    organizationName: 'IHG_AMER_STAYBRIDGE',
    extendedNetPrice: null,
  }],
  'device_claims2022-01-17': [{
    date: '2022-01-17',
    deviceModel: 'MR30H',
    deviceSerial: 'Q2RD-NVUB-FHRN',
    deviceType: 'wireless',
    networkName: 'MRYHA-IC-Monterey CA-SGD',
    organizationName: 'IHG_AMER_INTERCONTINENTAL',
    extendedNetPrice: null
  }, {
    date: '2022-01-17',
    deviceModel: 'MR30H',
    deviceSerial: 'Q2RD-S9DY-UNRY',
    deviceType: 'wireless',
    networkName: 'SINHB-IC-Singapore SG-EMI',
    organizationName: 'IHG_EMEAA_EAST_SEAK_ENT',
    extendedNetPrice: null
  }, {
    date: '2022-01-17',
    deviceModel: 'MS120-24P',
    deviceSerial: 'Q2EX-8DXE-U25G',
    deviceType: 'switch',
    networkName: 'JKTCP-CP-Jakarta ID-EMI-Admin',
    organizationName: 'IHG - EMEAA East - Managed Hotels',
    extendedNetPrice: null
  }, {
    date: '2022-01-17',
    deviceModel: 'MS120-24P',
    deviceSerial: 'Q2EX-8GNL-XPDJ',
    deviceType: 'switch',
    networkName: 'JKTCP-CP-Jakarta ID-EMI-Admin',
    organizationName: 'IHG - EMEAA East - Managed Hotels',
    extendedNetPrice: null
  }],
  summaryRenewals365: {
    period: 365,
    statusCount: {
      active: 62174,
      expired: 48190,
      expiringSoon: 4405,
      inGracePeriod: 5758,
    },
    calendar: {
      '2022-01-01': {
        devicesCount: {
          appliance: 39,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 252,
          systemsManager: 0,
          total: 1728,
          wireless: 1437,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-02-01': {
        devicesCount: {
          appliance: 65,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 458,
          systemsManager: 0,
          total: 3306,
          wireless: 2783,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-03-01': {
        devicesCount: {
          appliance: 96,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 615,
          systemsManager: 0,
          total: 4276,
          wireless: 3565,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-04-01': {
        devicesCount: {
          appliance: 125,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 776,
          systemsManager: 0,
          total: 5689,
          wireless: 4788,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-05-01': {
        devicesCount: {
          appliance: 126,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 691,
          systemsManager: 0,
          total: 6057,
          wireless: 5240,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-06-01': {
        devicesCount: {
          appliance: 109,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 765,
          systemsManager: 0,
          total: 5890,
          wireless: 5016,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-07-01': {
        devicesCount: {
          appliance: 104,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 947,
          systemsManager: 0,
          total: 5335,
          wireless: 4284,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-08-01': {
        devicesCount: {
          appliance: 95,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 550,
          systemsManager: 0,
          total: 5207,
          wireless: 4562,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-09-01': {
        devicesCount: {
          appliance: 111,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 588,
          systemsManager: 0,
          total: 5566,
          wireless: 4867,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-10-01': {
        devicesCount: {
          appliance: 148,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 734,
          systemsManager: 0,
          total: 6602,
          wireless: 5720,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-11-01': {
        devicesCount: {
          appliance: 92,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 505,
          systemsManager: 0,
          total: 5761,
          wireless: 5164,
        },
        networksCount: {
          total: 90
        },
      },
      '2022-12-01': {
        devicesCount: {
          appliance: 73,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 424,
          systemsManager: 0,
          total: 3617,
          wireless: 3120,
        },
        networksCount: {
          total: 90
        },
      },
      '2023-01-01': {
        devicesCount: {
          appliance: 51,
          camera: 0,
          cellularGateway: 0,
          environmental: 0,
          sensor: 0,
          switch: 356,
          systemsManager: 0,
          total: 3140,
          wireless: 2733,
        },
        networksCount: {
          total: 90
        },
      },
    }
  },
  summaryRenewals180: {
    statusCount: {
      'active': 29581,
      'expiringSoon': 4405,
      'expired': 48190,
      'inGracePeriod': 5758
    },
    'calendar': {
      '2022-07-01': {
        'devicesCount': {
          'total': 2635,
          'wireless': 2019,
          'switch': 573,
          'appliance': 43,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-04-01': {
        'devicesCount': {
          'total': 5689,
          'wireless': 4788,
          'switch': 776,
          'appliance': 125,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-06-01': {
        'devicesCount': {
          'total': 5890,
          'wireless': 5016,
          'switch': 765,
          'appliance': 109,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-03-01': {
        'devicesCount': {
          'total': 4276,
          'wireless': 3565,
          'switch': 615,
          'appliance': 96,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-05-01': {
        'devicesCount': {
          'total': 6057,
          'wireless': 5240,
          'switch': 691,
          'appliance': 126,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-01': {
        'devicesCount': {
          'total': 3306,
          'wireless': 2783,
          'switch': 458,
          'appliance': 65,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-01': {
        'devicesCount': {
          'total': 1728,
          'wireless': 1437,
          'switch': 252,
          'appliance': 39,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      }
    },
    'period': 180
  },
  summaryRenewals90: {
    statusCount: {
      'active': 12545,
      'expiringSoon': 4405,
      'expired': 48190,
      'inGracePeriod': 5758
    },
    'calendar': {
      '2022-03-01': {
        'devicesCount': {
          'total': 4276,
          'wireless': 3565,
          'switch': 615,
          'appliance': 96,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-01': {
        'devicesCount': {
          'total': 3306,
          'wireless': 2783,
          'switch': 458,
          'appliance': 65,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-01': {
        'devicesCount': {
          'total': 1728,
          'wireless': 1437,
          'switch': 252,
          'appliance': 39,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-04-01': {
        'devicesCount': {
          'total': 3235,
          'wireless': 2748,
          'switch': 409,
          'appliance': 78,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      }
    },
    'period': 90
  },
  summaryRenewals31: {
    statusCount: {
      'active': 4405,
      'expiringSoon': 4405,
      'expired': 48190,
      'inGracePeriod': 5758
    },
    'calendar': {
      '2022-01-28': {
        'devicesCount': {
          'total': 2,
          'wireless': 0,
          'switch': 2,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-29': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-30': {
        'devicesCount': {
          'total': 65,
          'wireless': 51,
          'switch': 13,
          'appliance': 1,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-31': {
        'devicesCount': {
          'total': 144,
          'wireless': 120,
          'switch': 20,
          'appliance': 4,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-01': {
        'devicesCount': {
          'total': 76,
          'wireless': 61,
          'switch': 12,
          'appliance': 3,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-02': {
        'devicesCount': {
          'total': 151,
          'wireless': 127,
          'switch': 20,
          'appliance': 4,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-03': {
        'devicesCount': {
          'total': 790,
          'wireless': 715,
          'switch': 69,
          'appliance': 6,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-04': {
        'devicesCount': {
          'total': 1,
          'wireless': 0,
          'switch': 0,
          'appliance': 1,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-05': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-06': {
        'devicesCount': {
          'total': 185,
          'wireless': 147,
          'switch': 33,
          'appliance': 5,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-07': {
        'devicesCount': {
          'total': 172,
          'wireless': 142,
          'switch': 24,
          'appliance': 6,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-08': {
        'devicesCount': {
          'total': 419,
          'wireless': 362,
          'switch': 51,
          'appliance': 6,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-09': {
        'devicesCount': {
          'total': 176,
          'wireless': 151,
          'switch': 21,
          'appliance': 4,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-10': {
        'devicesCount': {
          'total': 95,
          'wireless': 74,
          'switch': 19,
          'appliance': 2,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-11': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-12': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-13': {
        'devicesCount': {
          'total': 203,
          'wireless': 185,
          'switch': 14,
          'appliance': 4,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-14': {
        'devicesCount': {
          'total': 199,
          'wireless': 104,
          'switch': 89,
          'appliance': 6,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-15': {
        'devicesCount': {
          'total': 123,
          'wireless': 112,
          'switch': 9,
          'appliance': 2,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-16': {
        'devicesCount': {
          'total': 45,
          'wireless': 32,
          'switch': 12,
          'appliance': 1,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-17': {
        'devicesCount': {
          'total': 33,
          'wireless': 23,
          'switch': 9,
          'appliance': 1,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-18': {
        'devicesCount': {
          'total': 9,
          'wireless': 9,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-19': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-20': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-21': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-22': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-23': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-24': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-25': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-26': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-27': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-02-28': {
        'devicesCount': {
          'total': 0,
          'wireless': 0,
          'switch': 0,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-26': {
        'devicesCount': {
          'total': 530,
          'wireless': 461,
          'switch': 60,
          'appliance': 9,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-23': {
        'devicesCount': {
          'total': 210,
          'wireless': 169,
          'switch': 36,
          'appliance': 5,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-21': {
        'devicesCount': {
          'total': 132,
          'wireless': 114,
          'switch': 16,
          'appliance': 2,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-27': {
        'devicesCount': {
          'total': 163,
          'wireless': 144,
          'switch': 17,
          'appliance': 2,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-24': {
        'devicesCount': {
          'total': 10,
          'wireless': 3,
          'switch': 7,
          'appliance': 0,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-20': {
        'devicesCount': {
          'total': 234,
          'wireless': 181,
          'switch': 46,
          'appliance': 7,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      },
      '2022-01-25': {
        'devicesCount': {
          'total': 238,
          'wireless': 194,
          'switch': 35,
          'appliance': 9,
          'camera': 0,
          'sensor': 0,
          'environmental': 0,
          'systemsManager': 0,
          'cellularGateway': 0
        }
      }
    },
    'period': 31
  },
}
